import { Link, useLocation } from 'react-router-dom';
import Layout from '../components/feature/Layout';
import SEO from '../components/feature/SEO';

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <SEO
        title="Página no encontrada | SafeLine Solutions"
        description="La página que buscas no existe o fue movida. Vuelve al inicio de SafeLine Solutions."
        noIndex
      />

      <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-6 pt-20 bg-white overflow-hidden">
        <h1 className="absolute bottom-0 text-[10rem] md:text-[16rem] font-black text-gray-50 select-none pointer-events-none leading-none">
          404
        </h1>

        <div className="relative z-10 max-w-xl">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Error 404
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
            No pudimos encontrar esta página
          </h2>

          <p className="text-gray-600 leading-relaxed mb-2">
            La página <span className="font-mono text-sm text-gray-500 break-all">{location.pathname}</span> no existe o fue movida.
          </p>

          <p className="text-gray-600 leading-relaxed mb-10">
            Vuelve al inicio o revisa nuestros servicios HSE.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="bg-teal-600 text-white px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-teal-700 transition-colors inline-flex items-center justify-center gap-2 whitespace-nowrap shadow-lg hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
            >
              <i className="ri-home-4-line"></i>
              Volver al inicio
            </Link>

            <Link
              to="/servicios"
              className="border-2 border-gray-200 text-gray-700 px-8 py-3.5 rounded-lg text-base font-semibold hover:border-teal-300 hover:text-teal-700 transition-colors inline-flex items-center justify-center gap-2 whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500"
            >
              Ver servicios
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
